import { render } from "./AdditionalDetails.vue?vue&type=template&id=6182bca5&scoped=true"
import script from "./AdditionalDetails.vue?vue&type=script&lang=js"
export * from "./AdditionalDetails.vue?vue&type=script&lang=js"

import "./AdditionalDetails.vue?vue&type=style&index=0&id=6182bca5&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/lauryncoleman/lauryncoleman/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6182bca5"]])

export default __exports__